import { render, staticRenderFns } from "./UserRegisterPackageHistory.vue?vue&type=template&id=ce13e3b6&scoped=true"
import script from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"
export * from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce13e3b6",
  null
  
)

export default component.exports